'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.renderNode = renderNode;
exports.renderTree = renderTree;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _2 = require('../');

var _tree = require('./tree');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var tags = {
  a: 'a',
  br: 'br',
  button: 'button',
  div: 'div',
  form: 'form',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  hr: 'hr',
  iframe: 'iframe',
  img: 'img',
  input: 'input',
  label: 'label',
  option: 'option',
  p: 'p',
  picture: 'picture',
  pre: 'pre',
  select: 'select',
  span: 'span',
  textarea: 'textarea'
};

var eventName = function eventName(nodeName, type) {
  return _lodash2.default.camelCase('on ' + nodeName + ' ' + type);
};

var eventTypes = ['blur', // 'change', we don't do change event cause withFormHandler handles input changes
'click', 'doubleClick', 'focus', 'keyDown', 'keyUp', 'mouseDown', 'mouseEnter', 'mouseLeave', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp'];

function eventHandlersForNode(node, eventHandlers) {
  return _lodash2.default.reduce(eventTypes, function (result, type) {
    var n = eventName(node.name, type);

    if (_lodash2.default.has(eventHandlers, n) && _lodash2.default.isFunction(eventHandlers[n])) {
      return _extends({}, result, _defineProperty({}, _lodash2.default.camelCase('on ' + type), eventHandlers[n]));
    }

    return result;
  }, {});
}

function renderNode(node, options) {
  var nodeWithData = (0, _tree.mapDataToNode)(options.data, node);
  var attrs = options.noStyle === true ? _lodash2.default.omit(nodeWithData.p, 'style') : nodeWithData.p;

  if (!_lodash2.default.has(attrs, 'key')) {
    attrs = _extends({}, attrs, {
      key: attrs.className
    });
  }

  attrs = _lodash2.default.pickBy(attrs, function (v, k) {
    return !_lodash2.default.startsWith(k, '_');
  });

  if (nodeWithData.tag === 'a') {
    var url = _lodash2.default.startsWith(nodeWithData.p.href, '/') ? new window.URL(nodeWithData.p.href, window.location.origin).href : nodeWithData.p.href;

    if (url === window.location.href) {
      attrs = _extends({}, attrs, {
        className: attrs.className + ' mason-active-link'
      });
    }
  }

  if (nodeWithData.tag === 'children') {
    if (options.children && _react2.default.isValidElement(options.children)) {
      return options.children;
    }

    return null;
  }

  attrs = _extends({}, attrs, eventHandlersForNode(nodeWithData, options.eventHandlers));

  if (nodeWithData.tag === 'button') {
    if (!_lodash2.default.has(attrs, 'onClick') || !_lodash2.default.isFunction(attrs.onClick)) {
      attrs.onClick = function (e) {
        // we can't have buttons with no onClick handlers
        // if they're in forms they cause the browser to submit
        e.preventDefault();
      };
    }
  } // render text spans and text nodes


  if (node.tag === 'null' || !node.tag) {
    return nodeWithData.t;
  }

  var tag = _lodash2.default.isString(node.tag) ? _lodash2.default.get(tags, node.tag, 'div') : node.tag; // turn custom tags into divs

  if (nodeWithData.tag === 'mason-canvas') {
    return (0, _reactHyperscript2.default)(tag, attrs, (0, _reactHyperscript2.default)(_2.Canvas, _extends({}, attrs, {
      id: attrs['data-id'] || attrs.id
    })));
  } else if (_lodash2.default.has(nodeWithData, 'c')) {
    return (0, _reactHyperscript2.default)(tag, attrs, _lodash2.default.map(nodeWithData.c, function (child) {
      return renderNode(child, options);
    }));
  } else if (_lodash2.default.has(nodeWithData, 't')) {
    return (0, _reactHyperscript2.default)(tag, _extends({}, attrs, {
      dangerouslySetInnerHTML: {
        __html: nodeWithData.t
      }
    }));
  }

  return (0, _reactHyperscript2.default)(tag, attrs);
}

function renderTree(tree) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    data: {},
    eventHandlers: {},
    noStyle: false,
    paginator: _lodash2.default.noop
  };
  return _lodash2.default.map(tree, function (node) {
    return renderNode(node, options);
  });
}